module.exports = __webpack_public_path__ + "img/default_drawed.7eb25b0c.png";